module.exports = __webpack_public_path__ + "img/P150T_weapon_101.5f3153be.png";